<div class="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
    <div class="row">
        <div class="col-md-12">
            <ng-content></ng-content>
        </div>
    </div>
</div>